import type React from 'react';

export const StripeProvider: React.FC<{
  children: React.ReactElement | React.ReactElement[];
  merchantIdentifier?: string;
}> = ({ children }) => <>{children}</>;
